'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _omit2 = require('lodash/omit');

var _omit3 = _interopRequireDefault(_omit2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _dom = require('../../utils/dom');

var _sticky = require('./sticky.css');

var _sticky2 = _interopRequireDefault(_sticky);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function anchorTop(_ref, child) {
  var x = _ref.x,
      y = _ref.y,
      offset = _ref.offset;

  return {
    x: x + offset.x,
    y: y - child.height + offset.y
  };
}

function anchorRight(_ref2) {
  var x = _ref2.x,
      y = _ref2.y,
      width = _ref2.width,
      offset = _ref2.offset;

  return {
    x: x + width + offset.x,
    y: y + offset.y
  };
}

function anchorBottom(_ref3) {
  var x = _ref3.x,
      y = _ref3.y,
      height = _ref3.height,
      offset = _ref3.offset;

  return {
    x: x + offset.x,
    y: y + height + offset.y
  };
}

function anchorBottomCenter(_ref4, child) {
  var x = _ref4.x,
      y = _ref4.y,
      height = _ref4.height,
      width = _ref4.width,
      offset = _ref4.offset;

  return {
    x: x + offset.x + width / 2 - child.width / 2,
    y: y + height + offset.y
  };
}

function anchorLeft(_ref5, child) {
  var x = _ref5.x,
      y = _ref5.y,
      offset = _ref5.offset;

  return {
    x: x - child.width + offset.x,
    y: y + offset.y
  };
}

function anchorNone(_ref6) {
  var x = _ref6.x,
      y = _ref6.y,
      offset = _ref6.offset;

  return {
    x: x + offset.x,
    y: y + offset.y
  };
}

/** map of prop friendly names to anchor functions */
var anchors = {
  top: anchorTop,
  right: anchorRight,
  bottom: anchorBottom,
  'bottom center': anchorBottomCenter,
  left: anchorLeft,
  none: anchorNone
};

/**
 * Determine if a specific axis should be fixed or not
 * @param {object|boolean|undefined} fixed See Sticky component `fixed` prop
 * @param {string} axis x/y
 * @returns {boolean}
 */
function isFixed(fixed, axis) {
  if (fixed === true) {
    return true;
  }

  if (!fixed) {
    return false;
  }

  return !!fixed[axis];
}

/**
 * The Sticky component positions its children absolutely against
 * the border of the parent element. You can configure which
 * border (top, left, bottom, right) to stick to as well as a
 * margin.
 *
 * @class  {component} Sticky
 * @exports Sticky
 * @extends {React.Component}
 */

var Sticky = function (_React$Component) {
  (0, _inherits3.default)(Sticky, _React$Component);

  function Sticky() {
    (0, _classCallCheck3.default)(this, Sticky);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Sticky.__proto__ || Object.getPrototypeOf(Sticky)).call(this));

    _this.updatePosition = _this.updatePosition.bind(_this);
    return _this;
  }

  /**
    When the component has mounted and we have a reference to our root element
    We can create a new 'wormhole' element to mount into.
   */


  (0, _createClass3.default)(Sticky, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.el = document.createElement('div');
      this.el.style.position = 'absolute';
      this.el.style.transition = this.props.transition ? this.props.transition : '';
      document.body.appendChild(this.el);
      _reactDom2.default.unstable_renderSubtreeIntoContainer(this, this.renderChildren(), this.el, function () {
        return _this2.updatePosition();
      });
      window.addEventListener('resize', this.updatePosition);
      window.addEventListener('lys:z-scroll', this.updatePosition);
    }

    /**
      When the component updates we need to also re-render into our wormhole
      as well as update its absolute position.
     */

  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var _this3 = this;

      // only update if we aren’t forcing this sticky to be static
      if (!this.props.static) {
        _reactDom2.default.unstable_renderSubtreeIntoContainer(this, this.renderChildren(), this.el, function () {
          return _this3.updatePosition();
        });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      // TODO - keep an eye on this react issue
      // https://github.com/facebook/react/issues/2410
      if (!this.el) return;

      _reactDom2.default.unmountComponentAtNode(this.el);
      document.body.removeChild(this.el);
      window.removeEventListener('resize', this.updatePosition);
      window.removeEventListener('lys:z-scroll', this.updatePosition);
    }

    /*
      We update the position of our 'wormhole' mount based around the current
      fixed offset position of the parent and the current dimensions of our
      child.
     */

  }, {
    key: 'updatePosition',
    value: function updatePosition() {
      var _props = this.props,
          anchor = _props.anchor,
          offset = _props.offset,
          width = _props.width,
          safeZone = _props.safeZone,
          zIndex = _props.zIndex,
          fixed = _props.fixed,
          noPointerEvents = _props.noPointerEvents;
      var root = this.refs.root;

      var parent = _reactDom2.default.findDOMNode(root).parentNode;
      if (!parent) return;
      var position = (0, _dom.getFixedOffset)(parent);
      var child = this.el.children[0];

      var anchoredPosition = anchors[anchor]({
        x: position.left,
        y: position.top,
        height: parent.clientHeight,
        width: parent.clientWidth,
        offset: offset
      }, {
        height: child.clientHeight,
        width: child.clientWidth
      });

      // Fit into window
      var windowTop = window.scrollY + safeZone.y;
      var windowRight = window.scrollX + window.innerWidth - safeZone.x;
      var windowBottom = window.scrollY + window.innerHeight - safeZone.y;
      var windowLeft = window.scrollX + safeZone.x;
      var childRight = anchoredPosition.x + child.clientWidth;
      var childbottom = anchoredPosition.y + child.clientHeight;

      // TODO: All these anchor/offset/contain calculations could be nicely abstracted into some math/layout utils
      if (!isFixed(fixed, 'x') && childRight > windowRight) {
        anchoredPosition.x -= childRight - windowRight;
      }

      if (!isFixed(fixed, 'y') && childbottom > windowBottom) {
        anchoredPosition.y -= childbottom - windowBottom;
      }

      // top left is favoured (ie. we don’t adjust size of sticky just ensure top left is in view)
      if (!isFixed(fixed, 'x')) {
        anchoredPosition.x = Math.max(windowLeft, anchoredPosition.x);
      }
      if (!isFixed(fixed, 'y')) {
        anchoredPosition.y = Math.max(windowTop, anchoredPosition.y);
      }

      this.el.style.zIndex = zIndex;
      this.el.style.left = anchoredPosition.x + 'px';
      this.el.style.top = anchoredPosition.y + 'px';
      if (width) {
        this.el.style.width = parent.clientWidth / 100 * width + 'px';
      }
      if (noPointerEvents) {
        this.el.style.pointerEvents = 'none';
      }
    }
  }, {
    key: 'renderChildren',
    value: function renderChildren() {
      var _props2 = this.props,
          children = _props2.children,
          _IGNORED = _props2.offset,
          __IGNORED = _props2.anchor,
          ___IGNORED = _props2.zIndex,
          ____IGNORED = _props2.safeZone,
          _____IGNORED = _props2.transition,
          _______IGNORED = _props2.fixed,
          ________IGNORED = _props2.static,
          noPointerEvents = _props2.noPointerEvents,
          otherProps = (0, _objectWithoutProperties3.default)(_props2, ['children', 'offset', 'anchor', 'zIndex', 'safeZone', 'transition', 'fixed', 'static', 'noPointerEvents']);


      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({
          className: noPointerEvents ? _sticky2.default.transparent : null
        }, (0, _omit3.default)(otherProps, ['offset'])),
        children
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement('div', { className: _sticky2.default.root, ref: 'root' });
    }
  }]);
  return Sticky;
}(_react2.default.Component);

Sticky.propTypes = {
  children: _propTypes2.default.any,
  anchor: _propTypes2.default.oneOf(['top', 'left', 'bottom', 'bottom center', 'right', 'none']),
  transition: _propTypes2.default.string,
  width: _propTypes2.default.number,
  offset: _propTypes2.default.shape({
    x: _propTypes2.default.number,
    y: _propTypes2.default.number
  }),
  safeZone: _propTypes2.default.shape({
    x: _propTypes2.default.number,
    y: _propTypes2.default.number
  }),
  zIndex: _propTypes2.default.number,
  fixed: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object]),
  static: _propTypes2.default.bool,
  noPointerEvents: _propTypes2.default.bool
};
Sticky.defaultProps = {
  anchor: 'right',
  width: null,
  offset: { x: 0, y: 0 },
  safeZone: { x: 30, y: 30 },
  transition: '',
  zIndex: 0,
  fixed: { x: false, y: true },
  static: false,
  noPointerEvents: false
};
exports.default = Sticky;


//////////////////
// WEBPACK FOOTER
// ./~/@kalo/ui/lib/components/sticky/sticky.js
// module id = 354
// module chunks = 114276838955818